import { MDText } from 'i18n-react';

import { vehicleType } from 'Utilities/helpers';

import step1Avif from '../../../../client/assets_seller/howitworks/homepage/2026/step-1.avif';
import step1Png from '../../../../client/assets_seller/howitworks/homepage/2026/step-1.jpg';
import step1Webp from '../../../../client/assets_seller/howitworks/homepage/2026/step-1.webp';
import step2Avif from '../../../../client/assets_seller/howitworks/homepage/2026/step-2.avif';
import step2Png from '../../../../client/assets_seller/howitworks/homepage/2026/step-2.jpg';
import step2Webp from '../../../../client/assets_seller/howitworks/homepage/2026/step-2.webp';
import step3Avif from '../../../../client/assets_seller/howitworks/homepage/2026/step-3.avif';
import step3Png from '../../../../client/assets_seller/howitworks/homepage/2026/step-3.jpg';
import step3Webp from '../../../../client/assets_seller/howitworks/homepage/2026/step-3.webp';
import step4Avif from '../../../../client/assets_seller/howitworks/homepage/2026/step-4.avif';
import step4Png from '../../../../client/assets_seller/howitworks/homepage/2026/step-4.jpg';
import step4Webp from '../../../../client/assets_seller/howitworks/homepage/2026/step-4.webp';
import Texts from '../text/howTo.json';

const T = new MDText(Texts);

const stepsTitle = T.translate('title');

const stepsConfig = (brand: string | null = null, path = '') => {
  const vehicleText = vehicleType(path);

  const vehicle = brand ?? vehicleText;

  return [
    {
      imgAvif: step1Avif,
      imgPng: step1Png,
      imgWebp: step1Webp,
      text: T.translate('step1.detail'),
      time: String(T.translate('step1.title')),
    },
    {
      imgAvif: step2Avif,
      imgPng: step2Png,
      imgWebp: step2Webp,
      text: T.translate('step2.detail', { vehicle }),
      time: String(T.translate('step2.title', { vehicle })),
    },
    {
      imgAvif: step3Avif,
      imgPng: step3Png,
      imgWebp: step3Webp,
      text: T.translate('step3.detail', { vehicle }),
      time: String(T.translate('step3.title')),
    },
    {
      imgAvif: step4Avif,
      imgPng: step4Png,
      imgWebp: step4Webp,
      text: T.translate('step4.detail', { vehicle }),
      time: String(T.translate('step4.title')),
    },
  ];
};

export { stepsConfig, stepsTitle };
